<template>
    <div class="app-shell">
        <header v-if="!$route.meta.hideNavbar" class="flex items-center" style="min-height: 60px; padding: 0 32px; background: #ffffff; border-bottom: 1px solid #dedede;">
            <div @click="navigateTo('home')" class="brand">
                <!-- <span class="brand-mark">N</span> -->
                <span>
                    <strong>NBA Decision Engine</strong>
                    <small>Agentic decisioning workspace</small>
                </span>
            </div>

            <div class="flex justify-between items-center q-ml-xl">
                <div class="tab-item q-py-sm q-px-md" :class="{ 'tab-active': $route.name === 'opportunity-hub' }" @click="navigateTo('opportunity-hub')">NBA Opportunity Hub</div>
                <div class="tab-item q-py-sm q-px-md q-ml-md" :class="{ 'tab-active': $route.name === 'agent-studio' }" @click="navigateTo('agent-studio')">NBA Agent Studio</div>
                <div class="tab-item q-py-sm q-px-md q-ml-md" :class="{ 'tab-active': $route.name === 'impact-center' }" @click="navigateTo('impact-center')">NBA Impact Center</div>
            </div>

            <q-space/>

            <div v-if="userInitials" class="user-summary">
                <span>Brand Lead</span>
                <q-btn flat round class="avatar-button" :aria-label="`Open user menu for ${userInitials}`">
                    <span class="avatar">{{ userInitials }}</span>
                    <q-menu anchor="bottom right" self="top right">
                        <q-list style="min-width: 140px">
                            <q-item v-close-popup clickable :disable="isLoggingOut" @click="handleLogout">
                                <q-item-section>Logout</q-item-section>
                            </q-item>
                        </q-list>
                    </q-menu>
                </q-btn>
            </div>
            <div v-else></div>
        </header>

        <router-view v-slot="{ Component }">
            <keep-alive :include="cachedViews">
                <component :is="Component" />
            </keep-alive>
        </router-view>
    </div>
</template>

<script>
import { displayName, logout } from "./auth.js";

export default {
    name: "App",

    data() {
        return {
            userInitials: "",
            isLoggingOut: false,
        };
    },

    created() {
        this.updateUserInitials();
    },

    computed: {
        // Strategize runs cohort simulations and chat streams that take minutes, so its
        // instance has to survive navigation instead of being torn down and rebuilt.
        // Landing on login means the session ended, which drops the cached instance.
        cachedViews() {
            return this.$route.name === "login" ? [] : ["StrategizeView", "NBAWorkbenchView", "CommandCenterView"];
        },
    },

    watch: {
        $route() {
            this.updateUserInitials();
        },
    },

    methods: {
        updateUserInitials() {
            this.userInitials = displayName()
                .split(" ")
                .filter(Boolean)
                .map((part) => part[0].toUpperCase())
                .join("");
        },

        async handleLogout() {
            if (this.isLoggingOut) return;

            this.isLoggingOut = true;
            try {
                await logout();
            } finally {
                this.isLoggingOut = false;
                this.$router.push({ name: "login" });
            }
        },

        navigateTo(route) {
            this.$router.push({ name: route });
        },
    },
};
</script>

<style>
* {
    box-sizing: border-box;
}

.tab-item {
    cursor: pointer;
    color: #4b4b4b;
    font-size: 14px;
    font-weight: 600;
}

.tab-active {
    background: #262626;
    color: #ffffff;
    border-radius: 8px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
}

.tab-item:hover {
    color: #ff4e00;
    background: #f4f4f4;
    border-radius: 8px;
}

.tab-active:hover {
    color: #ffffff;
    background: #555555;
    border-radius: 8px;
}

body {
    margin: 0;
    min-width: 320px;
    font-family: Arial, Helvetica, sans-serif;
    color: #1f1f1f;
}

.brand {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #1f1f1f;
    text-decoration: none;
    white-space: nowrap;
    cursor: pointer;
}

.brand-mark {
    width: 32px;
    height: 32px;
    display: grid;
    place-items: center;
    border-radius: 4px;
    background: #ff4e00;
    color: #ffffff;
    font-size: 18px;
    font-weight: 700;
}

.brand strong,
.brand small {
    display: block;
}

.brand strong {
    font-size: 14px;
}

.brand small,
.user-summary {
    color: #6b6b6b;
    font-size: 11px;
}

.primary-nav {
    display: flex;
    align-items: stretch;
    align-self: stretch;
    gap: 32px;
}

.primary-nav a {
    display: flex;
    align-items: center;
    border-bottom: 3px solid transparent;
    color: #4b4b4b;
    font-size: 14px;
    text-decoration: none;
}

.primary-nav a:hover,
.primary-nav a.router-link-active {
    border-color: #ff4e00;
    color: #1f1f1f;
}

.user-summary {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-left: auto;
}

.avatar {
    width: 32px;
    height: 32px;
    display: grid;
    place-items: center;
    border-radius: 50%;
    background: #e8e8e8;
    color: #3c3c3c;
    font-size: 11px;
    font-weight: 700;
}

.avatar-button {
    min-width: 32px;
    min-height: 32px;
    padding: 0;
}

@media (max-width: 700px) {
    .top-bar {
        padding: 12px 20px;
        gap: 20px;
        flex-wrap: wrap;
    }

    .primary-nav {
        order: 3;
        width: 100%;
        height: 36px;
        gap: 20px;
    }
}
</style>
